// extracted by mini-css-extract-plugin
var _1 = "MyOrdersPageStyle-module__orders-container___MnZRP";
var _2 = "MyOrdersPageStyle-module__orders-container___MnZRP";
var _3 = "MyOrdersPageStyle-module__title___FBR39";
export { _1 as "orders-container", _2 as "ordersContainer", _3 as "title" }
